'use client';

import { useParams } from 'next/navigation';
import React from 'react';

import TicketButtonGrouped from '@/app/[locale]/(default-layout)/program/_components/TicketButtonGrouped';

import { ShowingDto } from '@cineamo/api/models/showing/ShowingDto.types';

import { CachedContentData } from '@/hooks/useCachedContentData';
import useShowingsListFiltered from '@/hooks/useShowingsListFiltered';

import { IconCircleCrossed24 } from '@cineamo/ui/src/icons/ic-circleCrossed';

import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

type ProgramDetailVerticalShowingsListProps = {
    date: string | 'all';
    content: CachedContentData;
    showingsCount: number;
    initialShowings: ShowingDto[];
    initialShowingsUpdatedAt: number;
};
export function ProgramDetailVerticalShowingsList(props: ProgramDetailVerticalShowingsListProps): React.JSX.Element {
    const { date, content, showingsCount, initialShowings, initialShowingsUpdatedAt } = props;
    const domainConfiguration = useDomainConfiguration();
    const { contentId } = useParams();

    const { showings, isFetchingShowingList, noShowingsForSelectedCinemas } = useShowingsListFiltered({
        contentId: Number(contentId),
        selectedDate: props.date,
        initialShowings: initialShowings,
        initialShowingsUpdatedAt: initialShowingsUpdatedAt
    });

    return (
        <div className="flex flex-col w-full space-y-12">
            {noShowingsForSelectedCinemas && (
                <div className="h-[96px] flex items-center justify-center opacity-20">
                    <IconCircleCrossed24 />
                </div>
            )}

            {showings.map((showing) => (
                <div
                    key={`TicketButtonGrouped#${showing.id}`}
                    className="h-[132px]">
                    <TicketButtonGrouped
                        showing={showing}
                        content={content}
                        showDateAndTime={['soon', 'all'].includes(date)}
                        showTags
                        style={{
                            backgroundColor: domainConfiguration.style.surfaceColor,
                            color: domainConfiguration.style.onSurfaceColor
                        }}
                    />
                </div>
            ))}
            {isFetchingShowingList &&
                [...Array(Math.max(0, showingsCount))].map((_, index) => {
                    return (
                        <div
                            key={`Skeleton#${index}`}
                            className="w-full h-[132px] animate-pulse-skeleton rounded-4"
                            style={{
                                backgroundColor: domainConfiguration.style.surfaceColor
                            }}
                        />
                    );
                })}
        </div>
    );
}
